"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyCode = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Code_1 = require("../Code");
const CopyButton_1 = require("../../2-inline-block/CopyButton");
const CopyCode = ({ value, truncate, onMouseDown, style, ...rest }) => {
    const codeStyle = truncate ? { minWidth: 0, maxWidth: '100%', ...(style || {}) } : style;
    return (React.createElement(Code_1.Code, { gray: true, spacious: true, ...rest, style: codeStyle, onMouseDown: (event) => {
            try {
                const element = event.nativeEvent.target;
                if (!element)
                    return;
                if (window.getSelection && document.createRange) {
                    const selection = window.getSelection();
                    if (!selection)
                        return;
                    event.preventDefault();
                    const range = document.createRange();
                    range.selectNodeContents(element);
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            }
            catch { }
            onMouseDown?.(event);
        } },
        React.createElement("span", { style: {
                display: 'inline-flex',
                alignItems: 'center',
                maxWidth: '100%',
                minWidth: 0,
                ...(truncate ? { overflow: 'hidden' } : {}),
            } },
            React.createElement("span", { style: truncate
                    ? {
                        display: 'inline-block',
                        minWidth: 0,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }
                    : undefined }, value),
            React.createElement(CopyButton_1.CopyButton, { onCopy: () => value }))));
};
exports.CopyCode = CopyCode;
